import { useEffect, useState } from "react";
import { AuthLayout } from "@/components/AuthLayout";
import { LoginForm } from "@/components/LoginForm";
import { ForgotForm } from "@/components/ForgotForm";
import { fetchMe, goToSite } from "@/lib/api";

export default function LoginPage() {
  const [mode, setMode] = useState("login");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    fetchMe().then((u) => (u ? goToSite() : setChecking(false)));
  }, []);

  if (checking) return <div className="min-h-screen bg-cream" data-testid="auth-checking" />;

  return mode === "login" ? (
    <AuthLayout title="Bienvenue" subtitle="Connecte-toi pour accéder à ton espace.">
      <LoginForm onSuccess={goToSite} onForgot={() => setMode("forgot")} />
    </AuthLayout>
  ) : (
    <AuthLayout title="Mot de passe oublié" subtitle="Indique ton email, je t'envoie un lien pour en choisir un nouveau.">
      <ForgotForm onBack={() => setMode("login")} />
    </AuthLayout>
  );
}
